import logo from './images/tb-logo.png';
import footerLogo from './images/tb-footer-gold.png';
import { Outlet, Link } from 'react-router';
import React from "react";
import { useAuth } from "./contexts/AuthContext";
import muiTheme from './theme/muiTheme';
import './theme/index.css';
import { ThemeProvider } from '@mui/material';

function App() {
  const { currentUser } = useAuth();

  return (
    <ThemeProvider theme={muiTheme}>
      <div className="app">
        <header className="header">
          <div className="logo">
            {currentUser === null ? (
              <Link to="/"><img src={logo} alt="TruBalance Bioenergetics" /></Link>
            ) : (
              <Link to="/dashboard"><img src={logo} alt="TruBalance Bioenergetics" /></Link>
            )}
          </div>
          <nav className="navBar">
            {currentUser === null ? (
              <Link to="/">Home</Link>
            ) : (
              <>
                <Link to="/dashboard">Dashboard</Link>
                {currentUser.role === 'admin' && <Link to={`/admin/reports`}>Reports</Link>}
                {currentUser.role === 'practitioner' && <Link to={`/training/${currentUser.uid}`}>Training</Link>}
                <Link to="/sign-out">Sign Out</Link>
              </>
            )}
          </nav>
        </header>
        <main className="content">
          <Outlet />
        </main>
        <footer className="footer">
          <a href="https://trubalancebioenergetics.com">
            <img src={footerLogo} alt="TruBalance Bioenergetics" />
          </a>
        </footer>
      </div>
    </ThemeProvider>
  );
}

export default App;